import { from as observableFrom, Observable } from "rxjs";
import { catchError, first, map, switchMap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import * as cornerstoneWebImageLoader from "cornerstone-web-image-loader";
import { GlobalVariable } from "app/global/global";
import { ArchivoService } from "./archivo.service";

declare const cornerstone;
declare const cornerstoneWADOImageLoader;
declare const cornerstoneWebImageLoader;

@Injectable()
export class CornerstoneService {
  constructor(private archivoService: ArchivoService) {
    cornerstoneWebImageLoader.external.cornerstone = cornerstone;

    cornerstoneWADOImageLoader.webWorkerManager.initialize({
      webWorkerPath:
        GlobalVariable.BASE_FRONT_URL +
        "assets/cornerstone/webworkers/cornerstoneWADOImageLoaderWebWorker.js",
      taskConfiguration: {
        decodeTask: {
          codecsPath:
            GlobalVariable.BASE_FRONT_URL +
            "assets/cornerstone/codecs/cornerstoneWADOImageLoaderCodecs.js",
        },
      },
      maxWebWorkers: navigator.hardwareConcurrency || 1,
      startWebWorkersOnDemand: true,
    });

    cornerstoneWebImageLoader.configure({
      beforeSend: function (xhr) {
        // Add custom headers here (e.g. auth tokens)
      },
    });
  }

  fetchLocalDicomImage(url: string): Observable<any> {
    //
    return observableFrom(cornerstone.loadImage(`wadouri:${url}`)).pipe(
      first()
    );
  }

  fetchDicomImage(imagen: any): Observable<any> {

    return this.archivoService
      .getImagenProtegida(
        imagen.idPaciente,
        imagen.idEstudioMedico,
        imagen.nombre
      )
      .pipe(
        map((blob: Blob) => {
          const objectUrl = URL.createObjectURL(blob);
          const dicomUrl = `wadouri:${objectUrl}`;
          return dicomUrl;
        }),
        switchMap((dicomUrl: string) =>
          observableFrom(cornerstone.loadImage(dicomUrl)).pipe(first())
        ),
        catchError((error) => {
          console.error("Error al cargar imagen DICOM protegida:", error);
          throw error;
        })
      );
  }
}
